import {NotificationService} from "../../services/NotificationService";
import {CustomFieldNameService} from "../../services/CustomFieldNameService";
import {SensorService} from "../../services/SensorService";

export class ReportVTagCommunicationModel {
    static $inject = ['$q','FileSaver','Blob','SensorService','CustomFieldNameService','NotificationService'];
    errorMessage:string = "";
    vtagType:string = "Any";
    vtagTypes:string[] = ["Any", "Fixed Position", "Asset"];
    daysToReport:number = 10;
    availableDaysToReport:number[] = [1,2,4,10,20,40,100,200,400];
    totalCount:number = 0;
    constructor(public $q:ng.IQService,
                public fileSaver:any,
                public blob:any,
                public sensorService:SensorService,
                public cfnService:CustomFieldNameService,
                public notifyService:NotificationService) {
    }

    getReport():ng.IPromise<any>{

        return this.sensorService.getReport(this.getPositionType(this.vtagType), this.daysToReport).then((data)=>{
            var blob = new Blob([data], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            });
            this.fileSaver.saveAs(blob, 'VTag_Communications.xlsx');
        })
            .catch((exc)=>{
                this.notifyService.notify("getReport err:"+exc);
            });
        return this.$q.when();
    }
    getCount():ng.IPromise<any>{
        //alert(this.location);
        return this.sensorService.getHistoryCountCounts(this.getPositionType(this.vtagType),this.daysToReport)
            .then((data)=>{
                this.totalCount = data;
            }).catch((exc)=>{
                this.notifyService.notify("Exception in getCount-"+exc);
            });
    }
    getPositionType(pt:string):string{
        switch(pt){
            case null:
            case "":
            case "Any":
                return "";
            case "Fixed Position":
                return "Fixed";
            case "Asset":
                return "Estimated";
            default:
                return "";
        }
    }
}

